import { useEffect } from 'react'

export const useHideElement = (
    selector: string,
    conditionToAddOpacity0: boolean,
    conditionToAddOpacity1: boolean
) => {
    useEffect(() => {
        const element = document.querySelector(selector)

        if (!element) {
            console.warn(`Element not found for selector: ${selector}`)
            return
        }

        if (conditionToAddOpacity0) {
            element.classList.remove('opacity-1')
            element.classList.add('opacity-0')
        } else if (conditionToAddOpacity1) {
            element.classList.remove('opacity-0')
            element.classList.add('opacity-1')
        } else {
            element.classList.remove('opacity-0', 'opacity-1')
        }
    }, [selector, conditionToAddOpacity0, conditionToAddOpacity1])
}
